import appGlobalScript from '/Users/henrygbc/Code/MO/webcomponents_bnpl-pe-bbva/src/global/global.ts';
export const globalScripts = appGlobalScript;
